/**
 * 共建店导入 2020-02-20
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '@/tool'
let { WizTypography,WizModal, WizSpin,WizTreeSelect } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'

class OrganizationFileImport extends WizContainer {

  componentName = 'organizationFileImport';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _componentDidMount() {

    this.doActions([
        {
            path: `organizationNodeCategory/getTypeNodeList`,
            payload: {
              key: `organization@orgNodeCategoryTree`,
              apiParams: {}
            }
        },{
        path: `organization/getNodeTreeData`,
        payload: {
          key: `organization@treeData`,
          apiParams: {}
        }
    },
    ],);
    const arr = [];
    this.setState({
        data: arr,
        treeData:[],
        orgNodeCategoryTree:[]
    });
}

  _handldImport(nextProps, nextState) {
    let o = nextProps['organizationImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'导入结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      let data = o['msg'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.error({
        title:'导入数据出错',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return false;
    }
  }
  _treeData(nextProps, nextState) {
    let o = nextProps['treeData']
    if (o['success']) {
        nextState['treeData'] = o['data']
    }
    return true
  }
  _orgNodeCategoryTree(nextProps, nextState) {
    let o = nextProps['orgNodeCategoryTree']
    if (o['success']) {
        nextState['orgNodeCategoryTree'] = o['data']
    }
    return true
  }

  propsAndStateOnChange = {
    treeData:this._treeData.bind(this),
    orgNodeCategoryTree:this._orgNodeCategoryTree.bind(this),
    organizationImport: this._handldImport.bind(this),
  }


  _render() {
    const{treeData,orgNodeCategoryTree} = this.state
    let record = this.props.location.record;
    let classInfoId = "";
    if (record) {
      classInfoId=record.classInfoId;
    }
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '组织导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_organizationTemp,
      }

    }
    let submit  = (file, fileData, other) => {
        const{parentId,organizationNodeCategory} = other
      let apiPath = 'organization/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "parentId":parentId,
            "organizationNodeCategory":organizationNodeCategory,
          }
        }
      });
    }

    let other = [
        {
          /**
           * item的参数
           */
          item: { label: '上级组织' },
          /**
           * 渲染内容的方法
           */
          comp: (callback) => {
            return (
              <WizTreeSelect treeData={treeData} onChange={(value) => {
              callback && callback('parentId', value) }} allowClear style={{ width: '100%' }}>
              </WizTreeSelect>
            )
          }
        },
        {
          /**
           * item的参数
           */
          item: { label: '组织类型',required:true },
          /**
           * 渲染内容的方法
           */
          comp: (callback) => {
            return (
              <WizTreeSelect treeData={orgNodeCategoryTree}  onChange={(value) => { callback && callback('organizationNodeCategory', value) }} style={{ width: '100%' }}>
              </WizTreeSelect>
            )
          }
        },
      ]

    let { organizationLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={organizationLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
          other={other}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { organization,organizationNodeCategory } = state;
  const organizationImport = modelUtils.getModelEntity(organization, 'import');
  const treeData = modelUtils.getModelEntity(organization, 'organization@treeData');
  const orgNodeCategoryTree = modelUtils.getModelEntity(organizationNodeCategory, 'organization@orgNodeCategoryTree');

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'organization','organizationNodeCategory')
  return {
    organizationImport,
    orgNodeCategoryTree,
    treeData,
    ...load
  }
};

export default connect(mapStateToProps)(OrganizationFileImport);
